<template>
  <v-chip
    :color="colorForRating"
    small
    text-color="black"
  >
    <template v-if="value">
      {{ value }} / 5
      <v-icon
        x-small
        color="black"
        right
      >
        mdi-star
      </v-icon>
    </template>
    <template v-else>
      <span style="width: 33px">
        -
      </span>
    </template>
  </v-chip>
</template>

<script setup lang="ts">
import { PropType, computed } from 'vue';

const props = defineProps(
  {
    value: { type: Number as PropType<Number | undefined>, required: true },
  },
);
const colorForRating = computed(() => {
  switch (props.value) {
    case 1: return 'red';
    case 2: return 'red lighten-1';
    case 3: return 'orange';
    case 4: return 'green lighten-3';
    case 5: return 'green';
    default: return 'grey';
  }
});
</script>
